export default "__VITE_ASSET__CPCpvdJw__"